import { v4 as uuidv4 } from 'uuid'
import { get, isEmpty, isString, map } from 'lodash'

export const STATUS = {
  WAITING: 'WAITING', // a file is waiting for upload
  ERROR: 'ERROR', // a file is in error state
  PROCESSING: 'PROCESSING', // busy processing or loading
  READY: 'READY' // all file uploaded
}

export const ERRORS = {
  MAX_FILES: 'MAX_FILES',
  MAX_FILE_SIZE: 'MAX_FILE_SIZE',
  WRONG_FILE_TYPE: 'WRONG_FILE_TYPE',
  FILE_EXISTS: 'FILE_EXISTS',
  NETWORK_ERROR: 'GENERAL_TECHNICAL_ERROR'
}

/**
 * @param value
 * @returns {number}
 */
function convertFileSize (value) {
  if (value === Infinity) {
    return value
  }
  let size = value.substr(0, value.length - 2)
  const byte = 1000
  const suffix = value.substr(-2)
  const sizes = {
    KB: byte,
    MB: Math.pow(byte, 2),
    GB: Math.pow(byte, 3)
  }

  return size * sizes[suffix]
}

class FileHandler {
  constructor (file, {filter, generateIdForNewFiles}) {
    this.file = file
    this.name = file.name || file.fileName

    if(file.fileId) {
      this.id = file.fileId
    } else if(generateIdForNewFiles) {
      this.id = uuidv4()
    }

    this.filter = filter

    this.percentage = undefined
    this.error = undefined
    this.validate()
  }

  getData () {
    return this.file
  }

  validate () {
    const { fileId, type, size } = this.file
    this.status = fileId ? STATUS.READY : STATUS.WAITING

    if (isEmpty(this.filter) || this.status === STATUS.READY) {
      return
    }

    map(this.filter, (value, filter) => {
      switch (filter) {
        case 'maxFileSize':
          if (size > convertFileSize(value)) {
            this.setError(ERRORS.MAX_FILE_SIZE)
          }
          break
        case 'acceptedFileTypes':
          const types = isString(value) ? value.split(',') : value
          if (!types.includes(type)) {
            this.setError(ERRORS.WRONG_FILE_TYPE)
          }
          break
      }
    })
  }

  onUploadProgress (progressEvent) {
    const progress = Math.round(progressEvent.loaded / progressEvent.total) * 100
    this.percentage = parseInt(progress)
    this.status = STATUS.PROCESSING
  }

  onSuccess (response) {
    const error = get(response, 'infoMessages[0].errorCode')
    if (error) {
      this.setError(error)
    } else {
      this.status = STATUS.READY
    }
    return this
  }

  onError (error) {
    this.setError(get(error, 'infoMessages[0].errorCode', ERRORS.NETWORK_ERROR))
    return this
  }

  setError (error) {
    this.error = error
    this.status = STATUS.ERROR
  }
}

export default FileHandler
